import { render } from "./SpinningIcon.vue?vue&type=template&id=f5ad0c7a"
const script = {}

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__